<script setup>
import searchMagnify from '../../../public/svg/search_magnify.svg'
import { defineModel } from "vue"
const model = defineModel()
</script>

<template>
    <v-text-field
        variant="solo-filled"
        v-model="model"
    >
        <template #prepend-inner>
            <v-img
                class="search-icon"
                :src="searchMagnify"
                alt=""
            />
        </template>
    </v-text-field>
</template>

<style scoped lang="scss">
:deep(.v-field--variant-solo), :deep(.v-field--variant-solo-filled) {
    box-shadow: none !important;
}

.search-icon {
    height: 40px;
    width: 40px;
}
</style>